import keymirror from 'keymirror';
import { AsyncRequest } from 'angieslist-app-platform';

export default keymirror({
  ...AsyncRequest.createActionKeys('SEND_APP_LINK'),
});



// WEBPACK FOOTER //
// ./src/app/common/download/appDownloadActionKeys.js